var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAllowed('createImportFile'))?_c('v-btn',{style:(_vm.theme),attrs:{"title":"Import using CSV file","to":{ name: 'ImportFile', params: { importFile: _vm.importData } }}},[_c('v-icon',{staticClass:"mx-2"},[_vm._v("mdi-file-import")]),_vm._v(" Import ")],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }